// Version : 1.0.0
// Author : AGALYA
const NomineeDetailsActionType = {
	/** ***************** NOMINEE DETAILS ADD START *********************** */
	NOMINEE_DETAILS_ADD_START: 'nominee_details_add_start',
	NOMINEE_DETAILS_ADD_SUCCESS: 'nominee_details_add_success',
	NOMINEE_DETAILS_ADD_FAILURE: 'nominee_details_add_failure',
	NOMINEE_DETAILS_ADD_RESPONSE_REST_START: 'nominee_details_add_response_reset_start',
	NOMINEE_DETAILS_ADD_RESPONSE_CHANGED: 'nominee_details_add_response_changed',
	/** ***************** NOMINEE DETAILS ADD END *********************** */
};

export default NomineeDetailsActionType;
